<template>
  <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
  >
    <van-cell v-for="(item,index) in books" :key="index">
      <router-link class="book-item" :to="flag === 'order'? '/orderBookDetail/' + item.bookId : '/bookDetail/' + item.bookId">
        <div class="cover">
	        <img v-if="item.coverUrl" :src="item.coverUrl" :key="item.bookId" referrerpolicy="no-referrer" @error="handleErrorImage($event)"/>
	        <img v-else :src="defaultCover()" :key="item.bookId"/>
				</div>
        <div class="right">
          <p class="title">{{ item.title }}</p>
          <p>
            <span class="price">￥{{ item.price }}</span>
            <span class="stock" v-if="type === 0">库存:{{ item.inventory }}</span>
          </p>
          <p>{{ item.author }}</p>
          <p>{{ item.publisher }} / {{ item.publicationDate }}</p>
          <p class="van-multi-ellipsis--l2" v-html="item.content"></p>
          <div class="vendor"><i class="iconfont icon-gongyingshang"></i>供应商：{{ item.vendorName }}</div>
          <!-- 当前在借 -->
          <p class="time" v-if="type === 1">借阅日期：{{ item.loanDate }}</p>
          <p class="time" v-if="type === 1">应还日期：{{ item.dueDate }}</p>
          <!-- 借阅历史 -->
          <p class="time" v-if="type === 2">借阅日期：{{ item.loanDate }}</p>
          <p class="time" v-if="type === 2">还书时间：{{ item.retDate }}</p>
        </div>
      </router-link>
    </van-cell>
  </van-list>
</template>

<script>
import {
  defineComponent,
  computed,
  ref
} from "vue";
import { randomBookCover} from "@/utils/util";
export default defineComponent({
  name: 'BookBlock',
  props: {
    list: {
      // 图书信息
      type: Array,
      default: () => []
    },
    type: {
      // 0: 基础页面，有新书速递+推荐图书+搜索结果， 1: 当前在借，2:借阅历史
      type: Number,
      default: 0
    },
    flag: {
      // order: 已下单的图书详情页
      type: String,
      default: ''
    },
  },
  setup(props, context) {
    const loading = ref(false);
    const finished = ref(false);
    const books = computed(() => {
        return props.list;
    });
    const onLoad = () => {
        context.emit('onLoad');
    };
		function handleErrorImage(event){
			event.srcElement.src = randomBookCover();
		}
		function defaultCover(){
			return randomBookCover();
		}
    return {
      onLoad,
		  books,
      loading,
      finished,
			handleErrorImage,
			defaultCover
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/book.less";
</style>
